module.exports = __webpack_public_path__ + "static/media/cellomatics-biosciences-limited.ac64d7f2.png";